import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import VariablePicker from "../../../FlowConfigurationInputs/VariablePicker/VariablePicker";
import DialogContent from "@material-ui/core/DialogContent";
import TextField from '@material-ui/core/TextField';
import Grid from "@material-ui/core/Grid";
import { Dialog, DialogTitle } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Close from "@material-ui/icons/Close";
/**
 * @Description this page OCR Library's Capture Text From Image Action's Capture Area
 * @Param       action - object
 * @Param       previewCanvasRef - cropping canvas reference
 * @Param       setOpenCaptureArea - open capture area function
 * @Param       crop - crop type
 * @Param       completedCrop - crop completed
 * @Param       setCompletedCrop - crop function
 * @Param       upImg - uploading image
 * @Param       imgRef - image reference
 * @Param       setFirstImageLoading - function
 * @Returns     canvas reference
 * @Author      Kerem Karadeniz
 */
const VariableAssign = ({
  setOpenCaptureArea,
  action,
  setImgCoordinate,
  imgCoordinate,
  setOpenVariable,
  variables,
  index,
  deleteCoordinate,
  isEdit
}) => {
  const { t } = useTranslation();
  useEffect(() => {
    if (!action.fields["v" + index]) {
      if (action.fields.completedCrop && action.fields.completedCrop.value[index] && action.fields.completedCrop.value[index]["variableName"]) {
        action.fields["v" + index] = { value: action.fields.completedCrop.value[index]["variableName"], variableType: action.fields.completedCrop.value[index]["variableType"] }
      } else {
        action.fields["v" + index] = { value: '' };
      }
    }
  }, [])
  // variable name is added to the selected array
  function handleAdd() {
    let variableName = action.fields["v" + index].value;
    if (variableName?.length > 0 && variableName !== undefined) {
      action.fields.completedCrop.value[index]["variableName"] = variableName;
      action.fields.completedCrop.value[index]["variableType"] = action.fields["v" + index].variableType;
      delete action.fields["v" + index]
      setOpenCaptureArea({ status: false, isEdit: false });
    }

  }

  //key press event 
  function handleKeyEvent(event) {
    if (event.key === 'Escape') {
      action.fields.completedCrop.value.splice(index, 1);
      imgCoordinate.coordinates.splice(index, 1);
      setImgCoordinate(imgCoordinate);
      setOpenCaptureArea({ status: false, isEdit: false });
    }
  }

  // const checkValidAndClose = () => {
  //   if (action.fields["v" + index]?.value) {
  //     delete action.fields["v" + index]
  //     setOpenCaptureArea({ status: false, isEdit: false })
  //   }
  // }

  return (
    <Dialog id="autom-addNew-modal" data-test="autom-add-new" open={true} onKeyDown={(e) => handleKeyEvent(e)}>
      <DialogTitle id="alert-dialog-title">
        {/* <Button
          style={{ backgroundColor: 'transparent' }}
          data-test="cancelautom-button"
          onClick={checkValidAndClose} 
        > */}
        <Close className="close-edit-button" onClick={() => {
          if (!isEdit) {
            let newImageCoordinate = imgCoordinate.coordinates
            newImageCoordinate.pop()
            deleteCoordinate(null, null, newImageCoordinate)
          }
          else {
            action.fields["v" + index].value = action.fields.completedCrop.value[index]["variableName"]
          }
          setOpenCaptureArea({ status: false, isEdit: false })
        }} />
        {/* </Button> */}
      </DialogTitle>
      <DialogContent>
        <div style={{ width: "200px" }}>
          <Grid container spacing={2}>
            <TextField
              style={{ marginLeft: 8, marginTop: 10, width: "80%" }}
              disabled
              fullWidth
              id="outlined-disabled"
              label="Crop Image Index"
              defaultValue={index + 1}
              variant="outlined"
            />

            <Grid item xs={12}>
              <VariablePicker
                action={action}
                inputName={"v" + index}
                variables={variables}
                setOpenVariable={setOpenVariable}
                isNull={false} system
                isRequired={true}
                index={index}
                inputNameChild="completedCrop"
                inputNameChildItemKey="variableName"
                filter="string"
              />
            </Grid>
          </Grid>
        </div>
      </DialogContent>
      <DialogContent>
        <Button variant="outlined" data-test="submitdialog-button"
          style={{ float: "right", backgroundColor: "#46474E", borderRadius: "2px", color: "#fff", width: "45%", border: "none" }}
          onClick={handleAdd}>
          {t("PARAMS-MODAL.SAVE")}
        </Button>
      </DialogContent>
    </Dialog>
  );
};

export default VariableAssign;
